import axios from 'axios';

const apiUrl = process.env.REACT_APP_SERVER_API_URL;

const cartService = {
    // Get current user's cart
    getCart: async () => {
        try {
            const response = await axios.get(`${apiUrl}/cart`);
            return response.data;
        } catch (error) {
            console.error('Error fetching cart:', error);
            // Return empty cart on error
            return { items: [] };
        }
    },

    // Add item to cart
    addToCart: async (item) => {
        try {
            const response = await axios.post(`${apiUrl}/cart/items`, item);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Remove item from cart by itemId
    removeFromCart: async (itemId) => {
        try {
            const response = await axios.delete(`${apiUrl}/cart/items/${itemId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Remove by week and kid (backward compatibility)
    removeByWeekAndKid: async (weekId, kidId) => {
        try {
            const params = { weekId };
            if (kidId) params.kidId = kidId;
            
            const response = await axios.delete(`${apiUrl}/cart/items`, { params });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Update cart item (e.g., bus option)
    updateCartItem: async (itemId, updates) => {
        try {
            const response = await axios.put(`${apiUrl}/cart/items/${itemId}`, updates);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Clear entire cart
    clearCart: async () => {
        try {
            const response = await axios.delete(`${apiUrl}/cart`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};

export default cartService;